@if (trainingDetails()) {
  <div class="www-pro-edu-tra-info">
    <div class="www-pro-edu-tra-info__desc">
      <img
        class="www-pro-edu-tra-info__wom-gla"
        src="assets/images/pages/account/pro-education/woman-glasses.webp"
        alt="Pro education Gallery Photo"
        [appAnimate]="'landing'"
        [speed]="'fast'"
        [delay]="'300'"
      />
    </div>

    <div class="www-pro-edu-tra-info__faq" [appAnimate]="'fadeInLeft'" [speed]="'fast'" [delay]="'600'">
      @if (trainingDetails()!.faqs.length > 0) {
        <p class="www-pro-edu-tra-info__faq__sub">NAJCZĘŚCIEJ ZADAWANE PYTANIA</p>
        <h2 class="www-pro-edu-tra-info__faq__tit">Przydatne informacje</h2>
      }

      @for (f of trainingDetails()!.faqs; track $index) {
        <app-pro-edu-tra-faq [faq]="f" />
      }
    </div>
  </div>
}
